import styled from "styled-components";

export const AboutMeWrapper = styled.div`
    display: grid;
    z-index: 1;
    height: 860px;
    width: 100%;
    max-width: 1100px;
    margin: auto;
    padding: 0 24px;
    justify-content: center;
`
